import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DocumentCategoryService } from 'src/app/platform/nomenclatoare/document-category/document-category.service';
import { DocumentTemplateSignaturesComponent } from 'src/app/platform/nomenclatoare/document-template/document-template-signatures/document-template-signatures.component';
import { DocumentTemplateService } from 'src/app/platform/nomenclatoare/document-template/document-template.service';
import { AuthService } from 'src/app/services/auth.service';
import { NotificationService } from 'src/app/services/notification.service';
import { environment } from 'src/environments/environment';
import { helper } from 'src/environments/helper';

@Component({
  selector: 'app-add-semnatari',
  templateUrl: './add-semnatari.component.html',
  styleUrls: ['./add-semnatari.component.scss'],
})
export class AddSemnatariComponent {
  errorTitle: string = environment.config.customNotifications.headers.error;
  errorIcon: string = environment.config.customNotifications.icons.error;
  errorType: string = environment.config.customNotifications.icons.error;
  helper = helper;
  successTitle: string = environment.config.customNotifications.headers.success;
  successIcon: string = environment.config.customNotifications.icons.success;
  successType: string = environment.config.customNotifications.icons.success;
  isLoading: boolean = false;
  token!: string;
  functiiOperator: any[] = [];

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: any,
    private dialogRef: MatDialogRef<AddSemnatariComponent>,
    private componentService: DocumentTemplateService,
    private notificationService: NotificationService,
    private authService: AuthService,
    private documentCategoryService: DocumentCategoryService
  ) {
    this.processToken();
  }
  closeDialog() {
    this.dialogRef?.close({
      success: false,
    });
  }

  processToken() {
    const tokenObj = this.authService.returnTokenUser();
    tokenObj.then((token) => {
      this.token = token;
      this.componentService.setToken(token);
    });
  }

  ngOnInit() {
    this.functiiOperator = this.data;
  }

  submitSemnatari() {}
}
